import { IVcfHealthReportSettingsResponse, IVcfHealthReportSettingsUpdate } from "./VcfHealthClient";

export interface IHealthReportSetting {
    readonly supported: boolean;
    readonly enabled: boolean;
    readonly interval?: number;
}

export interface ITimeBasedSetting extends IHealthReportSetting {
    readonly dayOfMonth?: number;
}

export interface IHealthReportSettings {
    readonly timeBased: ITimeBasedSetting
    readonly distanceBased: IHealthReportSetting
    readonly maintenanceBased: IHealthReportSetting
}

export class VcfHealthSettingsConverter {
    public static convertVcfResponseToHealthReportSettings(vcfResponse?: IVcfHealthReportSettingsResponse): IHealthReportSettings {
        const data = vcfResponse?.data;
        return {
            timeBased: {
                supported: data?.timeBasedSupported ?? false,
                enabled: data?.timeBased?.collectionPeriod === 'monthly',
                interval: this.fallbackToFirstElementIfNotInRange(data?.timeBased?.monthsBetweenReports, 3, 1),
                dayOfMonth: this.fallbackToFirstElementIfNotInRange(data?.timeBased?.dayOfMonth, 31, 1)
            },
            distanceBased: {
                supported: data?.distanceBasedSupported ?? false,
                enabled: (data?.distanceBased?.distance_km ?? 0) !== 0,
                interval: this.fallbackToFirstElementIfNotInRange(data?.distanceBased?.distance_km, 10, 1000)
            },
            maintenanceBased: {
                supported: data?.maintenanceBasedSupported ?? false,
                enabled: (data?.maintenanceBased?.distance_km ?? 0) !== 0,
                interval: this.fallbackToFirstElementIfNotInRange(data?.maintenanceBased?.distance_km, 10, 1000)
            }
        };
    }

    public static convertHealthReportSettingsToVcfData(healthReportSettings: IHealthReportSettings): IVcfHealthReportSettingsUpdate {
        return {
            timeBased: {
                collectionPeriod: healthReportSettings.timeBased.enabled ? 'monthly' : 'none',
                dayOfMonth: healthReportSettings.timeBased.dayOfMonth,
                monthsBetweenReports: healthReportSettings.timeBased.interval
            },
            distanceBased: {
                distance_km: healthReportSettings.distanceBased.enabled ? healthReportSettings.distanceBased.interval : 0
            },
            maintenanceBased: {
                distance_km: healthReportSettings.maintenanceBased.enabled ? healthReportSettings.maintenanceBased.interval : 0
            }
        };
    }

    private static fallbackToFirstElementIfNotInRange(value: number | undefined, numberOf: number, increment: number): number {
        const values = Array.from(Array(numberOf).keys(), x => (x + 1) * increment);
        return value && values.includes(value) ? value : values[0];
    }
}